import React from 'react'
import { connect } from 'react-redux'
import { clearHeader, clearSkip } from 'actions/general'
import LinkForm from './form'
import { postLink } from 'actions/link'
import { autoLoginRedirect } from 'util/redirect'
import { parse } from 'qs'
import { LoginRoute } from 'resources/routes'
import withRouter from 'hocs/with-router'

function mapStateToProps(state) {
  return {
    redirectUrl: state.general.get('portalUrl', null),
    loading: state.login.get('loading', false),
    submitError: state.login.get('error', false),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    clearHeader: payload => dispatch(clearHeader(payload)),
    clearSkip: payload => dispatch(clearSkip(payload)),
    postLink: payload => dispatch(postLink(payload)),
  }
}

class Link extends React.PureComponent {
  constructor(props) {
    super(props)

    const { appleIdToken, code: githubCode, flavor } = parse(
      props.location.search,
      { ignoreQueryPrefix: true }
    )

    if (!githubCode && !appleIdToken) {
      this.props.navigate(LoginRoute)
    } else {
      this.state = { appleIdToken, githubCode, flavor }
      this.authProvider = appleIdToken ? 'Apple' : 'Github'
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.props.submitError && this.props.redirectUrl) {
      autoLoginRedirect(this.props.navigate, this.props.redirectUrl, false)
    }
  }

  componentDidMount() {
    this.props.clearHeader()
    this.props.clearSkip()
  }

  _submit = values => {
    const submitValues = values
    submitValues.githubCode = this.state.githubCode || ''
    submitValues.appleIdToken = this.state.appleIdToken || ''
    submitValues.flavor = this.state.flavor
    return new Promise((resolve, reject) => {
      this.props.postLink({ values: submitValues, resolve, reject })
    })
  }

  render() {
    return (
      <div className='user'>
        <h1 className='heading--main'>Link your {this.authProvider} account</h1>
        <span className='heading--subheading'>
          We don’t recognize your {this.authProvider} account.
        </span>
        <span className='heading--subheading'>
          You can link your account by logging in with your VictorOps username
          and password below.
        </span>
        <LinkForm onSubmit={this._submit} loading={this.props.loading} />
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Link))
